import { ApiResponse, StaffLoginResponse, MessageResponse, TokenPairResponse, Staff } from '@mygate/common';
import { api } from './api';
import { useAuthStore } from '@/stores/authStore';

class StaffAuthService {
  async requestOtp(phoneNumber: string): Promise<ApiResponse<MessageResponse>> {
    return api.post('/api/staff/auth/request-otp', { phoneNumber });
  }

  async verifyOtp(phoneNumber: string, code: string): Promise<ApiResponse<StaffLoginResponse>> {
    return api.post('/api/staff/auth/verify-otp', { phoneNumber, code });
  }

  async refreshToken(): Promise<ApiResponse<TokenPairResponse>> {
    // Since we use cookies, the refresh token is sent automatically
    return api.post('/api/staff/auth/refresh');
  }

  async logout(): Promise<ApiResponse<MessageResponse>> {
    // Get refresh token from store to send with logout request
    const refreshToken = useAuthStore.getState().refreshToken;
    return api.post('/api/staff/auth/logout', { refreshToken });
  }

  async checkAuth(): Promise<boolean> {
    try {
      // Try to refresh token to check if we're still authenticated
      await this.refreshToken();
      return true;
    } catch {
      return false;
    }
  }

  async getProfile(): Promise<ApiResponse<Staff>> {
    return api.get('/api/staff/profile');
  }
}

export const staffAuthService = new StaffAuthService();
